module.exports = __webpack_public_path__ + "img/ico-bank.fd2afcca.svg";